export default "__VITE_ASSET__BmthSESI__"